import { useEffect } from "react";
import PersonService from "../../Services/Person.service";
import useService from "./useService";
/**
 * If a bunch of components use this at the same time, we'll still make a bunch of API calls if we wait to populate
 * the cache until after we get the user back.  Caching the promise itself helps.
 */
let cachedPromise;
/**
 * Just a minor thing, but if we can always return a person if we have one instead of null briefly before a user,
 * that will probably lead to less fidget-y experiences.  So, we additionally cache the user returned from the promise
 * and just return that if we have one.
 */
let cachedUser;
const getCachedUser = () => {
    if (!cachedPromise) {
        cachedPromise = PersonService.me();
    }
    return cachedPromise;
};
const useCurrentUser = () => {
    var _a;
    const [user, getUser] = useService(getCachedUser);
    useEffect(() => {
        if (!cachedUser) {
            getUser();
        }
    }, [getUser]);
    if (!cachedUser) {
        // get rid of undefined
        cachedUser = (_a = user.data) !== null && _a !== void 0 ? _a : null;
    }
    return cachedUser;
};
export default useCurrentUser;
